export default {
    app: {
        title: '屏幕尺寸检查器',
        subtitle: '一个方便测量显示屏宽度、高度和英寸的工具',
        description: '屏幕尺寸检查器是一个方便的工具，可以测量显示屏的宽度、高度和英寸。',
        width: '宽度',
        height: '高度',
        diagonal: '对角线',
        inches: '英寸',
        pixels: '像素',
        screen_size: '屏幕尺寸',
        resolution: '分辨率',
        aspect_ratio: '宽高比',
        pixel_density: '像素密度',
        ppi: 'PPI（每英寸像素数）',
        device_info: '设备信息',
        browser: '浏览器',
        os: '操作系统',
        language: '语言',
        home: '首页',
        privacy_policy: '隐私政策'
    }
};
